export const alarmData = [
  {
    images: [
      {
        index: 0,
        url: require("../../src/img/brand/Syracuse_University_2.png"),
      },
    ],
    alarms: [
      {
        name: "Critical",
        lastvalue: "25",
        color: "#F07162",
      },
      {
        name: "Major",
        lastvalue: "10",
        color: "#FC9D2B",
      },
      {
        name: "Warning",
        lastvalue: "13",
        color: "#5482B3",
      },
      {
        name: "Unacknowledged",
        lastvalue: "6",
        color: "#333840",
      },
      {
        name: "Minor",
        lastvalue: "22",
        color: "#F8D36A",
      },
      {
        name: "Informational",
        lastvalue: "18",
        color: "#A9B2BD",
      },
      {
        name: "All Alarms",
        lastvalue: "89",
        color: "#333840",
      },
    ],
  },
  {
    images: [
      {
        index: 0,
        url: require("../../src/img/brand/caesars-nobu.png"),
      },
    ],
    alarms: [
      {
        name: "Critical",
        lastvalue: "30",
        color: "#F07162",
      },
      {
        name: "Major",
        lastvalue: "15",
        color: "#FC9D2B",
      },
      {
        name: "Warning",
        lastvalue: "20",
        color: "#5482B3",
      },
      {
        name: "Unacknowledged",
        lastvalue: "8",
        color: "#333840",
      },
      {
        name: "Minor",
        lastvalue: "25",
        color: "#F8D36A",
      },
      {
        name: "Informational",
        lastvalue: "12",
        color: "#A9B2BD",
      },
      {
        name: "All Alarms",
        lastvalue: "100",
        color: "#333840",
      },
    ],
  },
];

export const syracuseData = {
  name: "Syracuse University",
  images: [
    {
      index: 0,
      url: require("../../src/img/brand/Syracuse_University_1.png"),
    },
  ],
  carriers: [
    {
      name: "AT&T",
      images: [
        {
          index: 0,
          url: require("../../src/img/brand/att-logo.png"),
        },
      ],
      yesterdayCount: 75,
      todayCount: 65,
      trend: "down",
      liveCount: 62,
      downloaded: 250,
      upload: 50,
    },
    {
      name: "Juice",
      images: [
        {
          index: 0,
          url: require("../../src/img/brand/Juice-logo.png"),
        },
      ],
      yesterdayCount: 150,
      todayCount: 200,
      trend: "up",
      liveCount: 175,
      downloaded: 220,
      upload: 150,
    },
    {
      name: "T-Mobile",
      images: [
        {
          index: 0,
          url: require("../../src/img/brand/T-Mobile_Logo.png"),
        },
      ],
      yesterdayCount: 100,
      todayCount: 150,
      trend: "up",
      liveCount: 150,
      downloaded: 280,
      upload: 200,
    },
  ],
};
export const caesarsData = {
  name: "Caesars Nobu",
  images: [
    {
      index: 0,
      url: require("../../src/img/brand/caesars-nobu.png"),
    },
  ],
  carriers: [
    {
      name: "AT&T",
      images: [
        {
          index: 0,
          url: require("../../src/img/brand/att-logo.png"),
        },
      ],
      yesterdayCount: 75,
      todayCount: 65,
      trend: "down",
      liveCount: 62,
      downloaded: 250,
      upload: 50,
    },
    {
      name: "Juice",
      images: [
        {
          index: 0,
          url: require("../../src/img/brand/Juice-logo.png"),
        },
      ],
      yesterdayCount: 150,
      todayCount: 200,
      trend: "up",
      liveCount: 175,
      downloaded: 220,
      upload: 150,
    },
    {
      name: "T-Mobile",
      images: [
        {
          index: 0,
          url: require("../../src/img/brand/T-Mobile_Logo.png"),
        },
      ],
      yesterdayCount: 100,
      todayCount: 150,
      trend: "up",
      liveCount: 150,
      downloaded: 280,
      upload: 200,
    },
  ],
};

export const CarrierColors = {
  "AT&T": "#00A8E1",
  Juice: "#FF8C00",
  "T-Mobile": "#E20074",
};

export const xranData = [
  {
    id: 1,
    systemName: 'Stadium of Light Stadium',
    jmaActivelyInvolved: true,
    region: 'Europe',
    topology: 'DAS',
    chModel: '',
    cascaded: false,
    technology: '4G',
    mobileOperator: 'EE, VMO2',
    frequencyBands: 'B3, B7, B8, B40, B1, B20',
    configuration: 'MIMO',
    bbuServerType: 'R7615',
    numberBbuServers: '3',
    numberOruc: '2',
    numberRanNodes: '1',
    numberSectors: '24(4G), 21(5G)',
    numberRadios: '264(4G)',
    tcpriPoi800: '2',
    tcpriPoi900: '',
    tcpriPoi1800: '4',
    tcpriPoi2100: '2',
    tcpriPoi2600: '3',
    tcpriPoi2300Tdd: '2',
    oranPoi35: '1',
    cellHub: '1',
    coreServerNumber: '1',
    coreRhVersion: '2',
    mocnBmServerNumber: '3',
    mocnBmServerType: '2',
    mocnBmRhVersion: '1',
    vmHostNumber: '2',
    vmGuestNumber: '1',
    vmRhVersion: '1',
    xoasHwOwner: '',
    xoasInstallation: '',
    xoasHw: '',
    dateRhelLoaded: '2025-01-10',
    sro210OnSiteRequired: false,
    currentSr: '',
    currentRedhat: '',
    currentDruidMocn: '',
    plannedSro210: '',
    targetSr: '',
    installed: false,
    activationDate: '',
    vertical: '',
    upgradeStatus: '',
    notes: '',
  },
  {
    id: 2,
    systemName: 'Signal Iduna Park Stadium',
    jmaActivelyInvolved: true,
    region: 'Europe',
    topology: 'DAS',
    chModel: '',
    cascaded: false,
    technology: '4G5G',
    mobileOperator: 'EE, VMO2Vodafone',
    frequencyBands: 'B3, B7, B8, B40, B1, B20',
    configuration: 'MIMO',
    bbuServerType: 'R7615',
    numberBbuServers: '3',
    numberOruc: '2',
    numberRanNodes: '1',
    numberSectors: '24(4G), 21(5G)',
    numberRadios: '264(4G)',
    tcpriPoi800: '2',
    tcpriPoi900: '',
    tcpriPoi1800: '4',
    tcpriPoi2100: '2',
    tcpriPoi2600: '3',
    tcpriPoi2300Tdd: '2',
    oranPoi35: '1',
    cellHub: '1',
    coreServerNumber: '1',
    coreRhVersion: '2',
    mocnBmServerNumber: '3',
    mocnBmServerType: '2',
    mocnBmRhVersion: '1',
    vmHostNumber: '2',
    vmGuestNumber: '1',
    vmRhVersion: '1',
    xoasHwOwner: '',
    xoasInstallation: '',
    xoasHw: '',
    dateRhelLoaded: '2025-02-15',
    sro210OnSiteRequired: true,
    currentSr: '',
    currentRedhat: '',
    currentDruidMocn: '',
    plannedSro210: '',
    targetSr: '',
    installed: false,
    activationDate: '',
    vertical: 'Stadium',
    upgradeStatus: '',
    notes: '',
  },
  {
    id: 3,
    systemName: 'Santiago Bernabeu Stadium',
    jmaActivelyInvolved: false,
    region: 'Europe',
    topology: 'C-RAN',
    chModel: '',
    cascaded: true,
    technology: '4G4G/5G',
    mobileOperator: 'EE, VMO2Telecom Italia',
    frequencyBands: 'B3, B7, B8, B40, B1, B20',
    configuration: 'MIMO',
    bbuServerType: 'R7615',
    numberBbuServers: '3',
    numberOruc: '2',
    numberRanNodes: '1',
    numberSectors: '24(4G), 21(5G)',
    numberRadios: '264(4G)',
    tcpriPoi800: '2',
    tcpriPoi900: '',
    tcpriPoi1800: '4',
    tcpriPoi2100: '2',
    tcpriPoi2600: '3',
    tcpriPoi2300Tdd: '2',
    oranPoi35: '1',
    cellHub: '1',
    coreServerNumber: '1',
    coreRhVersion: '2',
    mocnBmServerNumber: '3',
    mocnBmServerType: '2',
    mocnBmRhVersion: '1',
    vmHostNumber: '2',
    vmGuestNumber: '1',
    vmRhVersion: '1',
    xoasHwOwner: '',
    xoasInstallation: '',
    xoasHw: '',
    dateRhelLoaded: '2025-03-20',
    sro210OnSiteRequired: false,
    currentSr: '',
    currentRedhat: '',
    currentDruidMocn: '',
    plannedSro210: '',
    targetSr: '',
    installed: true,
    activationDate: '2025-04-01',
    vertical: 'Stadium',
    upgradeStatus: 'NEEDED',
    notes: '',
  },
  {
    id: 4,
    systemName: 'Allianz Arena Stadium',
    jmaActivelyInvolved: true,
    region: 'Europe',
    topology: 'DAS',
    chModel: '',
    cascaded: false,
    technology: '4G5G',
    mobileOperator: 'EE, VMO2O2',
    frequencyBands: 'B3, B7, B8, B40, B1, B20',
    configuration: 'MIMO',
    bbuServerType: 'R7615',
    numberBbuServers: '3',
    numberOruc: '2',
    numberRanNodes: '1',
    numberSectors: '24(4G), 21(5G)',
    numberRadios: '264(4G)',
    tcpriPoi800: '2',
    tcpriPoi900: '',
    tcpriPoi1800: '4',
    tcpriPoi2100: '2',
    tcpriPoi2600: '3',
    tcpriPoi2300Tdd: '2',
    oranPoi35: '1',
    cellHub: '1',
    coreServerNumber: '1',
    coreRhVersion: '2',
    mocnBmServerNumber: '3',
    mocnBmServerType: '2',
    mocnBmRhVersion: '1',
    vmHostNumber: '2',
    vmGuestNumber: '1',
    vmRhVersion: '1',
    xoasHwOwner: '',
    xoasInstallation: '',
    xoasHw: '',
    dateRhelLoaded: '2025-05-12',
    sro210OnSiteRequired: true,
    currentSr: '',
    currentRedhat: '',
    currentDruidMocn: '',
    plannedSro210: '',
    targetSr: '',
    installed: false,
    activationDate: '',
    vertical: 'Stadium',
    upgradeStatus: '',
    notes: '',
  },
  {
    id: 5,
    systemName: 'Old Trafford Stadium',
    jmaActivelyInvolved: true,
    region: 'Europe',
    topology: 'SBS',
    chModel: '',
    cascaded: true,
    technology: '4G4G',
    mobileOperator: 'EE, VMO2Vodafone',
    frequencyBands: 'B3, B7, B8, B40, B1, B20',
    configuration: 'MIMO',
    bbuServerType: 'R7615',
    numberBbuServers: '3',
    numberOruc: '2',
    numberRanNodes: '1',
    numberSectors: '24(4G), 21(5G)',
    numberRadios: '264(4G)',
    tcpriPoi800: '2',
    tcpriPoi900: '',
    tcpriPoi1800: '4',
    tcpriPoi2100: '2',
    tcpriPoi2600: '3',
    tcpriPoi2300Tdd: '2',
    oranPoi35: '1',
    cellHub: '1',
    coreServerNumber: '1',
    coreRhVersion: '2',
    mocnBmServerNumber: '3',
    mocnBmServerType: '2',
    mocnBmRhVersion: '1',
    vmHostNumber: '2',
    vmGuestNumber: '1',
    vmRhVersion: '1',
    xoasHwOwner: '',
    xoasInstallation: '',
    xoasHw: '',
    dateRhelLoaded: '2025-01-25',
    sro210OnSiteRequired: false,
    currentSr: '',
    currentRedhat: '',
    currentDruidMocn: '',
    plannedSro210: '',
    targetSr: '',
    installed: true,
    activationDate: '2025-02-10',
    vertical: 'Stadium',
    upgradeStatus: 'NEEDED',
    notes: '',
  },
  // ... (15 more records with identical structure - full file has 20 total records)
];





export const staticSuData = [
  {
    "itemid": "54764",
    "name": "Daily AT&T Rx Data",
    "lastvalue": "905022290696"
  },
  {
    "itemid": "54765",
    "name": "Daily AT&T Tx Data",
    "lastvalue": "124506903404"
  },
  {
    "itemid": "54763",
    "name": "Daily AT&T Users",
    "lastvalue": "6917"
  },
  {
    "itemid": "49128",
    "name": "Cumulative Rx Data",
    "lastvalue": "632728089772"
  },
  {
    "itemid": "49129",
    "name": "Cumulative Tx Data",
    "lastvalue": "97350659524"
  },
  {
    "itemid": "49121",
    "name": "Cumulative Combined Users",
    "lastvalue": "8717"
  },
  {
    "itemid": "49126",
    "name": "Cumulative AT&T Rx",
    "lastvalue": "362036830333"
  },
  {
    "itemid": "49125",
    "name": "Cumulative T-Mobile Rx",
    "lastvalue": "264037124833"
  },
  {
    "itemid": "49122",
    "name": "Cumulative Private Rx",
    "lastvalue": "6654134606"
  },
  {
    "itemid": "49127",
    "name": "Cumulative AT&T Tx",
    "lastvalue": "54549697626"
  },
  {
    "itemid": "49124",
    "name": "Cumulative T-Mobile Tx",
    "lastvalue": "32606541276"
  },
  {
    "itemid": "49123",
    "name": "Cumulative Private Tx",
    "lastvalue": "10194420622"
  },
  {
    "itemid": "49118",
    "name": "Cumulative AT&T Users",
    "lastvalue": "4878"
  },
  {
    "itemid": "49119",
    "name": "Cumulative T-Mobile Users",
    "lastvalue": "3504"
  },
  {
    "itemid": "49044",
    "name": "Live AT&T Users",
    "lastvalue": "694"
  },
  {
    "itemid": "49043",
    "name": "Live T-Mobile Users",
    "lastvalue": "394"
  },
  {
    "itemid": "49120",
    "name": "Cumulative Private Core Users",
    "lastvalue": "335"
  },
  {
    "itemid": "49045",
    "name": "Live Private Core Users",
    "lastvalue": "218"
  },
  {
    "itemid": "49046",
    "name": "Live Combined Users",
    "lastvalue": "1309"
  },
  {
    "itemid": "54769",
    "name": "Daily Private Rx Data",
    "lastvalue": "17381471240"
  },
  {
    "itemid": "54768",
    "name": "Daily Private Tx Data",
    "lastvalue": "18833045653"
  },
  {
    "itemid": "54761",
    "name": "Daily Private Users",
    "lastvalue": "373"
  },
  {
    "itemid": "54759",
    "name": "Get Daily",
    "lastvalue": ""
  },
  {
    "itemid": "54766",
    "name": "Daily T-Mobile Rx Data",
    "lastvalue": "594519210066"
  },
  {
    "itemid": "54767",
    "name": "Daily T-Mobile Tx Data",
    "lastvalue": "102990800347"
  },
  {
    "itemid": "54762",
    "name": "Daily T-Mobile Users",
    "lastvalue": "4881"
  },
  {
    "itemid": "54770",
    "name": "Daily Total Rx Data",
    "lastvalue": "1516922972002"
  },
  {
    "itemid": "54771",
    "name": "Daily Total Tx Data",
    "lastvalue": "246330749404"
  },
  {
    "itemid": "54760",
    "name": "Daily Total Users",
    "lastvalue": "12171"
  },
  {
    "itemid": "54772",
    "name": "Daily VoLTE Calls",
    "lastvalue": "11179"
  }
]